var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3515 6.90191L6.9 1.8479L8.03682 6.79507C8.18848 7.45508 8.66384 7.99351 9.29997 8.22581L13.34 9.70116L9.1567 11.2288C8.601 11.4318 8.16365 11.8703 7.96224 12.4266L6.44 16.6305L5.33138 12.5483C5.16119 11.9216 4.69733 11.4165 4.08734 11.1938L0 9.70116L4.1253 8.19467C4.71401 7.97968 5.1679 7.50116 5.3515 6.90191Z",
    fill: "#AC2E78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5783 2.42616L15.3074 0L15.8306 2.32142C15.9792 2.98061 16.4506 3.52021 17.0839 3.75598L18.8605 4.41746L16.9433 5.13126C16.389 5.33765 15.9544 5.77882 15.7565 6.33621L15.0536 8.31522L14.5583 6.45571C14.3914 5.82918 13.9311 5.32242 13.3235 5.09619L11.5005 4.41746L13.3607 3.72486C13.9475 3.5064 14.3981 3.02578 14.5783 2.42616Z",
    fill: "#AC2E78"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5137 13.3115L13.8801 12.011L14.1342 13.2136C14.2727 13.8691 14.7301 14.4116 15.3528 14.6589L16.1007 14.956L15.2212 15.3053C14.6726 15.5231 14.2483 15.9722 14.0618 16.5322L13.7214 17.5545L13.4942 16.6444C13.3381 16.0195 12.8906 15.5079 12.2919 15.2702L11.5007 14.956L12.3268 14.6279C12.9059 14.3979 13.3447 13.9112 13.5137 13.3115Z",
    fill: "#AC2E78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/starIcon.9f36ad1a3da06d48734bca93fac4484a.svg";
export { ForwardRef as ReactComponent };